import type { UploadFile } from 'element-plus'

export interface CreateRepairRequestForm {
  customer_id: number
  type: string
  request_date: Date
  expected_units: number | undefined
  scope_of_work: ScopeOfWorkService[]
  miner_models: string[]
  repair_fees: CustomRepairFeeItem[]
  signed_document?: UploadFile
}

export interface CustomRepairFeeItem {
  key: number
  repair_action_id: string | null
  price: number | undefined
}

export interface ScopeOfWorkService {
  key: number
  service_id: string | null
  price: number | undefined
  included_service_ids: number[] | undefined
}

export enum RepairRequestTypes {
  RSR = 'Repair Service Request',
  RMA = 'Return Merchandise Authorization',
  AAW = 'ASIC Warranty Claim',
}
